import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../middleware/dataSlice';


export const layoutAPI = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    processMakingCustomer: builder.query<{ companyId: string }, void>({
      query: (companyId) => ({
        url: `/Process/ProcessMakingCustomer?companyId=${companyId}`,
        method: 'GET'
      })
    }),
  }),
});

export const {
  useProcessMakingCustomerQuery,
} = layoutAPI;
